export default __webpack_public_path__ + "static/media/flip-btn.05342a27.png";